module.exports = __webpack_public_path__ + "img/home_59.718e3843.png";